import React from "react";
import { motion } from "framer-motion";
import { HOW_HOME_ASSIST_WORK } from "../../utils/Json";
import {
  Box,
  Grid,
  Card,
  Typography,
  CardContent,
  Container,
} from "@mui/material";
import EXPERTVISIT from "../../assets/icons/HomeAssistance/ExpertVisits.png";
import FIREBREAKOUTPROTECT from "../../assets/icons/HomeAssistance/FireBreakoutProtection.png";
import ONEAPPLIANCECOVER from "../../assets/icons/HomeAssistance/OneApplianceCover.png";
import QUICKCLAIMS from "../../assets/icons/HomeAssistance/QuickClaims.png";
import TRULYCASHLESS from "../../assets/icons/HomeAssistance/TrulyCashless.png";

const CARD_VARIANTS = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.2, duration: 0.6, ease: "easeOut" },
  }),
};

const BenefitsSection = () => {
  const HOW_HOME_ASSIST_WORK = [
    {
      image: ONEAPPLIANCECOVER,
      title: "All-in-One Appliance Cover",
      description:
        "Protect everything from ACs to washing machines under one plan.",
    },
    {
      image: QUICKCLAIMS,
      title: "Quick Claims/Policy Updates",
      description: "Tech-powered, hassle-free support in seconds.",
    },
    {
      image: EXPERTVISIT,
      title: "Expert Visits, On-Demand",
      description:
        "Certified technicians arrive quickly—when and where you need them.",
    },
    {
      image: TRULYCASHLESS,
      title: "Truly Cashless Repairs",
      description: "No hidden charges. No bills. Just seamless service.",
    },
  ];
  return (
    <Box
      sx={{
        py: 5,
      }}
    >
      <Container>
        <Box align="center">
          {/* <Heading title="How It Works" /> */}
          <Typography variant="h4" fontWeight={500} className="main-heading-font-size ">
            How It Works
          </Typography>
        </Box>

        <Box align="center" mt={{ xs: "0.6rem", sm: "0.6rem", md: "0.6rem" }}>
          {/* <GlobalSubHeading subTitle="Fast, expert help—right at your doorstep." /> */}
          <Typography variant="h6">
            Fast, expert help—right at your doorstep.
          </Typography>
        </Box>

        <Box sx={{ px: 0, py: { xs: 2, sm: 2, md: 4 } }}>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="stretch"
            wrap="wrap"
          >
            {HOW_HOME_ASSIST_WORK.map((benefit, index) => (
              <Grid
                item
                key={index}
                xs={12}
                sm={6}
                md={4}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <motion.div
                  custom={index}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  variants={CARD_VARIANTS}
                  style={{
                    width: "100%",
                    // maxWidth: 370
                  }}
                >
                  <Card
                    elevation={1}
                    sx={{
                      height: "100%",
                      borderRadius: 3,
                      // padding:'5px',
                      display: "flex",
                      boxShadow: "4px 8px 8px 0px #e4e2e1ff",
                      textAlign: "center",
                      // backgroundColor: "#FFFFFF",
                      backgroundColor: "#FFFFFF",
                      flexDirection: "column",
                      // width: { xs: 300, md: 370, lg: 273 },
                      width: { xs: 300, sm: 560, md: 530, lg: 273 },
                    }}
                  >
                    <img
                      src={benefit?.image}
                      alt={benefit?.title}
                      style={{
                        marginTop: 12,
                        width: "100%",
                        height: "60px",
                        objectFit: "contain",
                      }}
                    />
                    <CardContent>
                      <Typography
                        variant="h6"
                        gutterBottom
                        sx={{
                          fontWeight: "500",
                          fontFamily: '"Poppins", serif',
                          fontSize: {
                            xs: "0.9rem",
                            sm: "0.9rem",
                            md: "1.0rem",
                          },
                        }}
                      >
                        {benefit?.title}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        sx={{
                          fontFamily: '"Poppins", serif',
                          fontSize: {
                            xs: "0.86rem",
                            sm: "0.86rem",
                            md: "0.9rem",
                          },
                          textAlign: "center",
                          mb: -2,
                        }}
                      >
                        {benefit?.description}
                      </Typography>
                    </CardContent>
                  </Card>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default BenefitsSection;
